import { ApiProperty } from "@nestjs/swagger";
import { MessageTypeEnum, PriorityEnum } from "@schemax-whatsapp/shared-models";


export class BroadcastMessageRequest {
    companyId: number;
    templateName: string;
    templateLanguage: string;
    messageParams: JSON;
    contacts: string[];
    username: string;
    filePath?:string;
    fileName?:string;
    id?:number;

    /**
    * 
    * @param companyId 
    * @param templateName 
    * @param templateLanguage 
    * @param messageParams 
    * @param contacts 
    * @param username 
    */
    constructor(companyId: number, templateName: string, templateLanguage: string, messageParams: JSON, contacts: string[], username: string,filePath?:string,fileName?:string,id?:number) {
        this.companyId = companyId;
        this.templateName = templateName;
        this.templateLanguage = templateLanguage;
        this.messageParams = messageParams;
        this.contacts = contacts;
        this.username = username;
        this.fileName = fileName;
        this.filePath = filePath;
        this.id = id;
    }
}